export enum TriggerEnum {
	OrderAssignment = 1,
	PartStatusChangedToInTransit = 2,
	PartStatusChangedDelivered = 3,
	PartStatusChangedReceived = 4,
	PartStatusChangedInvoiced = 5,
	PartStatusChangedPaid = 6,
	OrderPartIsCancelled = 7,
	OrderPartIsReturned = 8,
	OrderIsReassigned = 9,
	OrderPartPriceIsEdited = 10,
	QuoteAwaitingRelease = 11,
	SendInvoicesUpdates = 12,
	ReceivePaymentVoucher = 13,
	ShippingCompanyChange = 14,
	TrackingCodeChange = 15,
	QuotePartCanceled = 16,
	PartInReturnProcess = 17,
	PartInReturnApproval = 18,
	QuoteManual = 19,
}
